export function toggleFilter(filterName) {
    return function toggle(filters) {
        if (filters.includes(filterName)) return filters.filter((f) => f !== filterName)
        return [...filters, filterName]
    }
}
